import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
import {eventLogger} from "../../lib/eventLogger.js";
import {Button, Select, Col, DatePicker, Form, Input, Row, Table} from "../../../__snowpack__/pkg/antd.js";
import LocaleContext from "../../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {isEmpty, map} from "../../../__snowpack__/pkg/lodash.js";
import moment from "../../../__snowpack__/pkg/moment-timezone.js";
import React, {useContext, useEffect, useState} from "../../../__snowpack__/pkg/react.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import {EllipsisTooltip} from "../EllipsisTooltip/index.js";
import {TableEmpty} from "../TableEmpty/index.js";
import {useLocation} from "../../../__snowpack__/pkg/react-router-dom.js";
import qs from "../../../__snowpack__/pkg/query-string.js";
import {bigPromotionTimeRange} from "../../lib/const.js";
const i18n = {
  "zh-cn": {
    operator: "\u64CD\u4F5C\u4EBA",
    createDate: "\u521B\u5EFA\u65F6\u95F4",
    time: "\u65F6\u95F4",
    content: "\u64CD\u4F5C\u5185\u5BB9",
    moduleOperation: "\u64CD\u4F5C\u6A21\u5757"
  },
  en: {
    operator: "Operator",
    createDate: "Creation Time",
    time: "Time",
    content: "Operation Content",
    moduleOperation: "Operation module"
  },
  id: {
    operator: "Operator",
    createDate: "Waktu Pembuatan",
    time: "Waktu",
    content: "Isi Pengaturan",
    moduleOperation: "Modul pengaturan"
  },
  th: {
    operator: "\u0E1C\u0E39\u0E49\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    createDate: "\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07",
    time: "\u0E40\u0E27\u0E25\u0E32",
    content: "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23",
    moduleOperation: "\u0E42\u0E21\u0E14\u0E39\u0E25\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23"
  },
  vi: {
    operator: "Ng\u01B0\u1EDDi th\u1EF1c hi\u1EC7n",
    createDate: "Th\u1EDDi gian T\u1EA1o",
    time: "Th\u1EDDi gian",
    content: "N\u1ED9i dung ho\u1EA1t \u0111\u1ED9ng",
    moduleOperation: "M\u1EE5c thao t\xE1c"
  }
};
var OPERATION_TYPE;
(function(OPERATION_TYPE2) {
  OPERATION_TYPE2["order"] = "ORDER_OPERATION_LOG";
  OPERATION_TYPE2["warehouse"] = "ORDER_WAREHOUSE_SETTING_LOG";
})(OPERATION_TYPE || (OPERATION_TYPE = {}));
export const OrderOperationLog = (props) => {
  const {pageType, eventLocation} = props;
  const [form] = Form.useForm();
  const {RangePicker} = DatePicker;
  const {locale} = useContext(LocaleContext);
  const {formatMessage} = useIntl();
  const {Column} = Table;
  const [operationModule, setModuleOperation] = useState([]);
  const [pageInfo, setPageInfo] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });
  let params = qs.parse(useLocation().search);
  const [timeRangeDates, setTimeRangeDates] = useState([
    moment("00:00:00", "HH:mm:ss"),
    moment("23:59:59", "HH:mm:ss")
  ]);
  useEffect(() => {
    eventLogger.push(eventLocation.page);
    getOperationType();
    form.setFieldsValue({
      keyword: params.keyword,
      timeRange: [moment().startOf("day"), moment().endOf("day")]
    });
    if (params.moduleKey) {
      getOperationList({moduleType: params.moduleKey});
    } else {
      getOperationList();
    }
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const [operationList, setOperationList] = useState([]);
  const getOperationList = async (params2 = {}) => {
    try {
      setIsLoading(true);
      const search = form.getFieldsValue();
      search.page = pageInfo.current - 1;
      search.size = pageInfo.pageSize;
      search.pageType = pageType;
      search.createDateFrom = search.timeRange && search.timeRange[0];
      search.createDateTo = search.timeRange && search.timeRange[1];
      delete search.timeRange;
      const {
        data: {content, number, size, totalElements}
      } = await axios.post(`/saas/order/operation-log-v2`, {
        ...search,
        ...params2
      });
      pageInfo.pageSize = size;
      pageInfo.current = number + 1;
      pageInfo.total = totalElements;
      setPageInfo(pageInfo);
      setIsLoading(false);
      setOperationList(content);
    } catch (error) {
      setIsLoading(false);
      handleError(error);
    }
  };
  const getOperationType = async () => {
    try {
      const {data} = await axios.post(`/saas/order/module-types`, {
        pageType
      });
      setModuleOperation(data);
      form.setFieldsValue({moduleType: params.moduleKey});
    } catch (error) {
      handleError(error);
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    style: {height: "100vh"}
  }, /* @__PURE__ */ React.createElement(Row, {
    className: "search-form"
  }, /* @__PURE__ */ React.createElement(Col, {
    span: 24
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: "inline",
    form
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "operator"
  }, /* @__PURE__ */ React.createElement(Input, {
    style: {width: "220px"},
    placeholder: i18n[locale].operator
  })), /* @__PURE__ */ React.createElement(Form.Item, {
    name: "timeRange"
  }, /* @__PURE__ */ React.createElement(RangePicker, {
    style: {width: "220px"},
    format: "DD-MM-YYYY",
    allowClear: false,
    placeholder: [i18n[locale].createDate, i18n[locale].createDate],
    defaultValue: timeRangeDates,
    inputReadOnly: true,
    disabledDate: (current) => {
      if (!timeRangeDates || timeRangeDates.length === 0) {
        return false;
      }
      let timeNumber = 30;
      if (bigPromotionTimeRange) {
        timeNumber = 7;
      }
      const tooLate = timeRangeDates[0] && current.diff(timeRangeDates[0], "days") > timeNumber;
      const tooEarly = timeRangeDates[1] && timeRangeDates[1].diff(current, "days") > timeNumber;
      return tooEarly || tooLate;
    },
    onCalendarChange: (val) => {
      setTimeRangeDates(val);
    },
    showTime: {
      hideDisabledOptions: true,
      defaultValue: [moment("00:00:00", "HH:mm:ss"), moment("23:59:59", "HH:mm:ss")]
    }
  })), pageType === OPERATION_TYPE.order && /* @__PURE__ */ React.createElement(Form.Item, null, /* @__PURE__ */ React.createElement(Input.Group, {
    compact: true
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "moduleType"
  }, /* @__PURE__ */ React.createElement(Select, {
    style: {width: "150px"},
    allowClear: true
  }, !isEmpty(operationModule) && map(operationModule, (item) => {
    return /* @__PURE__ */ React.createElement(Select.Option, {
      value: item.moduleCode,
      key: item.moduleCode
    }, item.moduleName);
  }))), /* @__PURE__ */ React.createElement(Form.Item, {
    name: "keyword"
  }, /* @__PURE__ */ React.createElement(Input, {
    defaultValue: params.keyword,
    style: {width: "220px"},
    placeholder: formatMessage({id: "OrdersID"})
  })))), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    disabled: isLoading,
    onClick: () => {
      eventLogger.push({...eventLocation.search});
      getOperationList({
        page: 0
      });
    },
    htmlType: "submit"
  }, formatMessage({id: "globalsSearch"}))))), /* @__PURE__ */ React.createElement(Table, {
    dataSource: operationList,
    loading: isLoading,
    locale: {emptyText: /* @__PURE__ */ React.createElement(TableEmpty, null)},
    pagination: pageInfo && {
      showSizeChanger: true,
      showTotal: (total) => {
        return formatMessage({id: "globalsTotalPage"}, {total});
      },
      current: pageInfo.current,
      pageSize: pageInfo.pageSize,
      total: pageInfo.total,
      pageSizeOptions: ["10", "50", "100"],
      showQuickJumper: true,
      onChange: (page, pageSize) => {
        getOperationList({
          page: page - 1,
          size: pageSize || 10
        });
        window.scrollTo(0, 0);
      }
    }
  }, /* @__PURE__ */ React.createElement(Column, {
    title: i18n[locale].time,
    render: (text, record) => record.operateDatetime ? moment(record.operateDatetime).format("DD-MM-YYYY HH:mm") : "-",
    width: 200
  }), pageType === OPERATION_TYPE.order && /* @__PURE__ */ React.createElement(Column, {
    width: 200,
    title: i18n[locale].moduleOperation,
    ellipsis: true,
    render: (text, record) => /* @__PURE__ */ React.createElement(EllipsisTooltip, {
      title: record.moduleTypeName || "-"
    })
  }), /* @__PURE__ */ React.createElement(Column, {
    title: i18n[locale].content,
    render: (text, record) => record.operationMessage.map((item) => /* @__PURE__ */ React.createElement("div", {
      dangerouslySetInnerHTML: {__html: item},
      style: {wordBreak: "break-all"}
    }))
  }), /* @__PURE__ */ React.createElement(Column, {
    title: i18n[locale].operator,
    render: (text, record) => record.operator,
    width: 200
  })));
};
const Wrapper = styled.div`
  background: #fff;
  .search-form {
    padding: 16px;
    padding-bottom: 0;
    background-color: #f7f8fa;
    border-bottom: 1px solid #dfe3e8;
  }
  .product-name {
    max-width: 100% !important;
    display: block;
  }
`;
